export default {
  computed: {
    computedOpenStreetMapStandardVisibility() {
      return this.$store.state.basemapLayers.openStreetMapStandard.visibility;
    }
  },
  methods: {
    basemapLayerOpenStreetMapStandardAdd() {
      this.map.addSource("osm-standard-source", {
        type: "raster",
        tiles: [
          "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png",
          "https://b.tile.openstreetmap.org/{z}/{x}/{y}.png"
        ],
        tileSize: 256
      });

      this.map.addLayer({
        id: "osm-standard-tiles",
        type: "raster",
        source: "osm-standard-source",
        minzoom: 0,
        maxzoom: 22
      });

      this.map.moveLayer("osm-standard-tiles", "marker-layer-bottom");
    },
    basemapLayerOpenStreetMapStandardRemove() {
      this.map.removeLayer("osm-standard-tiles");
      this.map.removeSource("osm-standard-source");
    }
  },
  watch: {
    "$store.state.basemapLayers.openStreetMapStandard.visibility": function(
      newValue
    ) {
      if (newValue === true) {
        this.basemapLayerOpenStreetMapStandardAdd();
      } else {
        this.basemapLayerOpenStreetMapStandardRemove();
      }
    }
  }
};
